import { filter, defaultTo, prop, isNotEmpty } from 'ramda';

// Pure computation: removes empty widget rows from a section.
// Must remain a direct derivation from props (no useState/useEffect):
// otherwise the first render displays 0 rows, and any code looking up a
// widget-card by its id right after mount (e.g. scroll/highlight from
// the previewer) cannot find it yet.
export const filterNonEmptyRows = (widgets) =>
  filter(w => isNotEmpty(prop('widgets', w)), defaultTo([], widgets));
